import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import * as selector from '../state/selector';
import * as operation from '../state/operation';

export const MachineVncExpirationModal = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);
  const dispatch = useDispatch();

  const { machineVncSession } = useSelector((state) => ({
    machineVncSession: selector.selectMachineVncSession(state)
  }));

  /**
   * @context session is expired
   * @description Handle action to close timeout message when the current session is expired
   */
  const handleHideMachineVncExpirationModal = () => {
    localStorage.removeItem('current-machine-session');
    dispatch(operation.hideMachineVncExpirationModal());
  };

  /**
   * @context session is expired
   * @description Handle action to access VNC session when the current session is expired
   */
  const handleAccessMachineVncInSessionExpiredModal = () => {
    dispatch(operation.hideMachineVncExpirationModal());
    dispatch(
      operation.requestMachineVncSession(
        localStorage.getItem('current-machine-session') || ''
      )
    );
  };

  return (
    <Modal
      title={t('machineVncExpirationModal.title')}
      open={machineVncSession.modal.expiration.visible}
      className="base-modal no-select"
      closable={false}
      width={550}
      destroyOnClose
      footer={[
        <Row>
          <Col span={12}>
            <Button
              size="s"
              className="cancel-btn"
              onClick={handleHideMachineVncExpirationModal}>
              {t('machineVncExpirationModal.backButton')}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              size="s"
              className="submit-btn base-yellow-btn"
              onClick={handleAccessMachineVncInSessionExpiredModal}>
              {t('machineVncExpirationModal.accessButton')}
            </Button>
          </Col>
        </Row>
      ]}>
      <pre className="machine-vnc-status-modal whitespace-normal">
        {t('machineVncExpirationModal.description')}
      </pre>
    </Modal>
  );
};
